import { useState } from 'react'
import { useToast } from '@navegasistemas/dls-navega-rjs'
import { useAuthStore } from '@/store/auth-store'
import { ApiError } from '@/services/api-client'
import { exportsService } from '@/features/file-exports/services/exports.service'
import { downloadBlob } from '@/utils/file-download'

export function useDownloadExport() {
  const [downloadingId, setDownloadingId] = useState<string | null>(null)
  const accessToken = useAuthStore((s) => s.accessToken)
  const { toast } = useToast()

  async function download(jobId: string) {
    if (!accessToken || downloadingId) return
    setDownloadingId(jobId)
    try {
      const { blob, filename } = await exportsService.downloadFile(jobId, accessToken)
      downloadBlob(blob, filename)
    } catch (err) {
      if (err instanceof ApiError) {
        if (err.status === 410) {
          toast({
            variant: 'danger',
            title: 'Arquivo expirado',
            message: 'Este arquivo expirou e não está mais disponível.',
          })
        } else if (err.status === 409) {
          toast({
            variant: 'danger',
            title: 'Arquivo não disponível',
            message: 'A exportação ainda está sendo processada.',
          })
        } else {
          toast({ variant: 'danger', title: 'Erro ao baixar', message: err.message })
        }
      } else {
        toast({ variant: 'danger', title: 'Erro ao baixar', message: 'Tente novamente.' })
      }
    } finally {
      setDownloadingId(null)
    }
  }

  return { download, downloadingId }
}
